/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsMultisiteWageGroupsCtrl
 * @description A report of wage totals and sales for all companies grouped by role wage group
 */
angular.module('mercury.modules.reports.multisite')
.controller('ReportsMultisiteWageGroupsCtrl', ["comparetime", "$filter", "multisite", "$q", "ReportItemCategories", "reporttime", "$scope", "TimeClock", "title", "userinfo", function(comparetime, $filter, multisite, $q, ReportItemCategories, reporttime, $scope, TimeClock, title, userinfo) {
  title.set('Staff Wages');
  multisite.setMultisite(true);

  $scope.results = [];
  $scope.compare = comparetime.time() !== null;
  $scope.graphColumns = [
    {label: 'Site', type: 'string', key: 'name'},
    {label: 'Wage Percent', type: 'number', key: 'totalPercent', filter: 'percent'}
  ];
  $scope.graphOptions = {
    vAxis: {format: 'decimal'},
    animation: null
  };
  $scope.foodSalesTotal = 0;
  $scope.foodSalesCompareTotal = 0;
  $scope.foodWageTotal = 0;
  $scope.foodWageCompareTotal = 0;

  $scope.beverageSalesTotal = 0;
  $scope.beverageSalesCompareTotal = 0;
  $scope.beverageWageTotal = 0;
  $scope.beverageWageCompareTotal = 0;

  $scope.totalSalesTotal = 0;
  $scope.totalSalesCompareTotal = 0;
  $scope.totalWageTotal = 0;
  $scope.totalWageCompareTotal = 0;

  var wageResults = {};
  var wageCompare = {};
  var salesResults = {};
  var salesCompare = {};

  var createResultLine = function(company) {
    // we don't want to add companies to the resultset multiple times, so check the restuls array and only add if it's a new companyId
    var newCompany = true;
    angular.forEach($scope.results, function(result) {
      if (result.companyId == company.id) {
        newCompany = false;
        result.show = '1';
      }
    });

    if (newCompany) {
      $scope.results.push({
        companyId: company.id,
        show: '1',
        name: company.name,
        foodWage: null,
        foodWageCompare: null,
        foodPercent: null,
        foodPercentCompare: null,
        foodSales: null,
        foodSalesCompare: null,
        beverageWage: null,
        beverageWageCompare: null,
        beveragePercent: null,
        beveragePercentCompare: null,
        beverageSales: null,
        beverageSalesCompare: null,
        totalWage: null,
        totalWageCompare: null,
        totalPercent: null,
        totalPercentCompare: null,
        totalSales: null,
        totalSalesCompare: null
      });
    }
  };

  var updateTotals = function() {
    $scope.foodSalesTotal = 0;
    $scope.foodSalesCompareTotal = 0;
    $scope.foodWageTotal = 0;
    $scope.foodWageCompareTotal = 0;

    $scope.beverageSalesTotal = 0;
    $scope.beverageSalesCompareTotal = 0;
    $scope.beverageWageTotal = 0;
    $scope.beverageWageCompareTotal = 0;

    $scope.totalSalesTotal = 0;
    $scope.totalSalesCompareTotal = 0;
    $scope.totalWageTotal = 0;
    $scope.totalWageCompareTotal = 0;

    angular.forEach($scope.results, function(resultLine) {
      if (resultLine.show != '1') {
        return;
      }
      $scope.foodSalesTotal += resultLine.foodSales;
      $scope.foodSalesCompareTotal += resultLine.foodSalesCompare;
      $scope.foodWageTotal += resultLine.foodWage;
      $scope.foodWageCompareTotal += resultLine.foodWageCompare;

      $scope.beverageSalesTotal += resultLine.beverageSales;
      $scope.beverageSalesCompareTotal += resultLine.beverageSalesCompare;
      $scope.beverageWageTotal += resultLine.beverageWage;
      $scope.beverageWageCompareTotal += resultLine.beverageWageCompare;

      $scope.totalSalesTotal += resultLine.totalSales;
      $scope.totalSalesCompareTotal += resultLine.totalSalesCompare;
      $scope.totalWageTotal += resultLine.totalWage;
      $scope.totalWageCompareTotal += resultLine.totalWageCompare;
    });

    $scope.foodPercentTotal = $scope.foodSalesTotal !== 0 ? ($scope.foodWageTotal / $scope.foodSalesTotal) * 100 : 0;
    $scope.foodPercentCompareTotal = $scope.foodSalesCompareTotal !== 0 ? ($scope.foodWageCompareTotal / $scope.foodSalesCompareTotal) * 100 : 0;
    $scope.beveragePercentTotal = $scope.beverageSalesTotal !== 0 ? ($scope.beverageWageTotal / $scope.beverageSalesTotal) * 100 : 0;
    $scope.beveragePercentCompareTotal = $scope.beverageSalesCompareTotal !== 0 ? ($scope.beverageWageCompareTotal / $scope.beverageSalesCompareTotal) * 100 : 0;
    $scope.totalPercentTotal = $scope.totalSalesTotal !== 0 ? ($scope.totalWageTotal / $scope.totalSalesTotal) * 100 : 0;
    $scope.totalPercentCompareTotal = $scope.totalSalesCompareTotal !== 0 ? ($scope.totalWageCompareTotal / $scope.totalSalesCompareTotal) * 100 : 0;
  };

  var getGroupSales = function(categoryTotals) {
    var foodTotal = $filter('filter')(categoryTotals, function(category) {
      return category.label.toLowerCase() == 'food';
    });

    var beverageTotal = $filter('filter')(categoryTotals, function(category) {
      return category.label.toLowerCase() == 'beverage';
    });

    return {
      food: $filter('sumof')(foodTotal, 'invoices') - $filter('sumof')(foodTotal, 'invoiceTax'),
      beverage: $filter('sumof')(beverageTotal, 'invoices') - $filter('sumof')(beverageTotal, 'invoiceTax'),
      total: $filter('sumof')(categoryTotals, 'invoices') - $filter('sumof')(categoryTotals, 'invoiceTax')
    };
  };

  var buildReport = function() {
    angular.forEach(userinfo.companies(), function(company) {
      if (multisite.isCompanyDisabled(company.id)) {
        angular.forEach($scope.results, function(result) {
          if (result.companyId == company.id) {
            result.show = '0';
          }
        });
        $scope.$emit('dataTableUpdate');
        return;
      }

      if (!wageResults[company.id]) {
        wageResults[company.id] = TimeClock.getSummaryByRole(reporttime.start(), reporttime.end(), company.id);
      }
      if (!salesResults[company.id]) {
        salesResults[company.id] = ReportItemCategories.getSales(reporttime.start(), reporttime.end(), company.id);
      }
      if ($scope.compare && !wageCompare[company.id]) {
        wageCompare[company.id] = TimeClock.getSummaryByRole(comparetime.start(), comparetime.end(), company.id);
      }
      if ($scope.compare && !salesCompare[company.id]) {
        salesCompare[company.id] = ReportItemCategories.getSales(comparetime.start(), comparetime.end(), company.id);
      }

      // TODO: Combine wageResults and SalesResults promises, or make sure you update both functions if anything changes
      wageResults[company.id].then(function(wageResult) {
        var foodWage = $filter('sumof')($filter('filter')(wageResult, {roleCostGroup: 'f'}), 'cost');
        var beverageWage = $filter('sumof')($filter('filter')(wageResult, {roleCostGroup: 'b'}), 'cost');
        var totalWage = $filter('sumof')(wageResult, 'cost');

        angular.forEach($scope.results, function(resultLine) {
          if (resultLine.companyId == company.id) {
            resultLine.foodWage = foodWage;
            resultLine.beverageWage = beverageWage;
            resultLine.totalWage = totalWage;

            if (resultLine.foodSales !== null) {
              resultLine.foodPercent = (resultLine.foodSales !== 0) ? (foodWage / resultLine.foodSales) * 100 : 0;
            }

            // Note that due to popular demand our beverage wage cost is calculated based on entire sales, not just beverage sales
            if (resultLine.beverageSales !== null) {
              resultLine.beveragePercent = (resultLine.beverageSales !== 0) ? (beverageWage / resultLine.totalSales) * 100 : 0;
            }
            if (resultLine.totalSales !== null) {
              resultLine.totalPercent = (resultLine.totalSales !== 0) ? (totalWage / resultLine.totalSales) * 100 : 0;
            }
          }
        });
        updateTotals();
        $scope.$emit('update.googleChart');
      });

      if (wageCompare[company.id]) {
        wageCompare[company.id].then(function(wageCompareResult) {
          var foodWageCompare = $filter('sumof')($filter('filter')(wageCompareResult, {roleCostGroup: 'f'}), 'cost');
          var beverageWageCompare = $filter('sumof')($filter('filter')(wageCompareResult, {roleCostGroup: 'b'}), 'cost');
          var totalWageCompare = $filter('sumof')(wageCompareResult, 'cost');

          angular.forEach($scope.results, function(resultLine) {
            if (resultLine.companyId == company.id) {
              resultLine.foodWageCompare = foodWageCompare;
              resultLine.beverageWageCompare = beverageWageCompare;
              resultLine.totalWageCompare = totalWageCompare;

              if (resultLine.foodSalesCompare !== null) {
                resultLine.foodPercentCompare = (resultLine.foodSalesCompare !== 0) ? (foodWageCompare / resultLine.foodSalesCompare) * 100 : 0;
              }
              if (resultLine.beverageSalesCompare !== null) {
                resultLine.beveragePercentCompare = (resultLine.beverageSalesCompare !== 0) ? (beverageWageCompare / resultLine.beverageSalesCompare) * 100 : 0;
              }
              if (resultLine.totalSalesCompare !== null) {
                resultLine.totalPercentCompare = (resultLine.totalSalesCompare !== 0) ? (totalWageCompare / resultLine.totalSalesCompare) * 100 : 0;
              }
            }
          });
          updateTotals();
          $scope.$emit('update.googleChart');
        });
      }

      salesResults[company.id].then(function(salesResult) {
        var groupSales = getGroupSales(salesResult);

        angular.forEach($scope.results, function(resultLine) {
          if (resultLine.companyId == company.id) {
            resultLine.foodSales = groupSales.food;
            resultLine.beverageSales = groupSales.beverage;
            resultLine.totalSales = groupSales.total;

            if (resultLine.foodWage !== null) {
              resultLine.foodPercent = (resultLine.foodSales !== 0) ? (resultLine.foodWage / resultLine.foodSales) * 100 : 0;
            }

            // Note that due to popular demand our beverage wage cost is calculated based on entire sales, not just beverage sales
            if (resultLine.beverageWage !== null) {
              resultLine.beveragePercent = (resultLine.beverageSales !== 0) ? (resultLine.beverageWage / resultLine.totalSales) * 100 : 0;
            }
            if (resultLine.totalWage !== null) {
              resultLine.totalPercent = (resultLine.totalSales !== 0) ? (resultLine.totalWage / resultLine.totalSales) * 100 : 0;
            }
          }
        });
        updateTotals();
        $scope.$emit('update.googleChart');
      });

      if (salesCompare[company.id]) {
        salesCompare[company.id].then(function(salesCompareResult) {
          var groupSales = getGroupSales(salesCompareResult);

          angular.forEach($scope.results, function(resultLine) {
            if (resultLine.companyId == company.id) {
              resultLine.foodSalesCompare = groupSales.food;
              resultLine.beverageSalesCompare = groupSales.beverage;
              resultLine.totalSalesCompare = groupSales.total;

              if (resultLine.foodWageCompare !== null) {
                resultLine.foodPercentCompare = (resultLine.foodSalesCompare !== 0) ? (resultLine.foodWageCompare / resultLine.foodSalesCompare) * 100 : 0;
              }
              if (resultLine.beverageWageCompare !== null) {
                resultLine.beveragePercentCompare = (resultLine.beverageSalesCompare !== 0) ?
                  (resultLine.beverageWageCompare / resultLine.totalSalesCompare) * 100 : 0;
              }
              if (resultLine.totalWageCompare !== null) {
                resultLine.totalPercentCompare = (resultLine.totalSalesCompare !== 0) ? (resultLine.totalWageCompare / resultLine.totalSalesCompare) * 100 : 0;
              }
            }
          });
          updateTotals();
          $scope.$emit('update.googleChart');
        });
      }

      createResultLine(company);
    });

    $scope.$emit('dataTableUpdate');
  };

  angular.forEach(userinfo.companies(), function(company) {
    if (multisite.isCompanyDisabled(company.id)) {
      angular.forEach($scope.results, function(result) {
        if (result.companyId == company.id) {
          result.show = '0';
        }
      });
      $scope.$emit('dataTableUpdate');
      return;
    }

    createResultLine(company);

    wageResults[company.id] = TimeClock.getSummaryByRole(reporttime.start(), reporttime.end(), company.id);
    salesResults[company.id] = ReportItemCategories.getSales(reporttime.start(), reporttime.end(), company.id);
    if ($scope.compare) {
      wageCompare[company.id] = TimeClock.getSummaryByRole(comparetime.start(), comparetime.end(), company.id);
      salesCompare[company.id] = ReportItemCategories.getSales(comparetime.start(), comparetime.end(), company.id);
    }
  });

  $scope.loading = $q.race(wageResults);
  $scope.loading.then(buildReport);
  $scope.$on('userInfoUpdated', buildReport);
}]);
